import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function RevelationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-gradient-to-b from-[#5d6e4f] to-[#4a5940] text-white" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-137">
          <SparklesIcon className="w-12 h-12 text-[#c9a961] mx-auto mb-6" data-id="element-138" />

          

          <div className="h-px bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mb-8" data-id="element-139"></div>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-140">
            He creado{' '}
            <span className="font-serif text-2xl md:text-3xl text-[#c9a961]" data-id="element-141">
              El Protocolo Meno-Metabólico
            </span>
            , un plan de 21 días que te enseña exactamente qué comer y cómo
            descansar para que tu cuerpo "suelte" el exceso de peso y recupere
            su energía natural. Sin necesidad de costosos reemplazos hormonales
            ni ingredientes imposibles de conseguir. Todo lo que necesitas está
            en el mercado o en el súper.
          </p>
        </motion.div>
      </div>
    </section>;
}